import { Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { Email as EmailIcon } from "@mui/icons-material";
import { FormEvent } from "react";

interface CodeRequestProps {
  codeEmail: string;
  codeLoading: boolean;
  onEmailChange: (email: string) => void;
  onSubmit: (e: FormEvent) => void;
  onBackToPassword: () => void;
  formClassName: string;
  codeButtonClassName: string;
  switchModeClassName: string;
}

const CodeRequest = ({
  codeEmail,
  codeLoading,
  onEmailChange,
  onSubmit,
  onBackToPassword,
  formClassName,
  codeButtonClassName,
  switchModeClassName
}: CodeRequestProps) => {
  return (
    <>
      <form className={formClassName} onSubmit={onSubmit}>
        <TextField
          label="Email Address"
          type="email"
          value={codeEmail}
          onChange={(e) => onEmailChange(e.target.value)}
          required
          fullWidth
          variant="outlined"
          helperText="We'll send a verification code to this email"
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={codeLoading}
          className={codeButtonClassName}
          startIcon={<EmailIcon />}
          sx={{ mt: 1 }}
        >
          {codeLoading ? (
            <><CircularProgress size={20} sx={{ mr: 1 }} />Sending Code...</>
          ) : (
            <>Send Verification Code</>
          )}
        </Button>
      </form>
      
      <Box textAlign="center" mt={2}>
        <Typography 
          variant="body2" 
          className={switchModeClassName}
          onClick={onBackToPassword}
        >
          Back to password login
        </Typography>
      </Box>
    </>
  );
};

export default CodeRequest;